import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toaster } from 'sonner';

import { useLoadAllEquipmentsRawQuery } from '@/entities/equipment/api/use-load-all-equipments.raw.query';
import { useLoadAllExercisesRawQuery } from '@/entities/exercise/api/use-load-all-exercises-raw.query';
import { useLoadAllMetricsRawQuery } from '@/entities/metrics/api/use-load-all-metrics-raw.query';
import { useLoadAllMovementsRawQuery } from '@/entities/movement/api/use-load-all-movements-raw.query';
import { useLoadAllMovementMuscleRawQuery } from '@/entities/movement-muscle/api/use-load-all-movement-muscle-raw.query';
import { useLoadAllMusclesRawQuery } from '@/entities/muscle/api/use-load-all-muscles-raw.query';
import { Footer } from '@/features/common/footer';
import { Header } from '@/features/common/header';
import { useIsRTL } from '@/hooks/i18n.hooks';
import { cn } from '@/lib/utils';

export const Route = createRootRoute({
	component: Root,
});

// @todo: make this a single query to load all the bootstrap data
function Root() {
	const isRTL = useIsRTL();
	const location = useLocation();
	const shouldShowFooter = location.pathname !== '/about-us';

	// Load metrics once at the app level - all components will read from Redux store
	useLoadAllMetricsRawQuery();

	// Load all equipments once at the app level - all components will read from Redux store
	useLoadAllEquipmentsRawQuery();

	// Load all movements once at the app level - all components will read from Redux store
	useLoadAllMovementsRawQuery();

	// Load all exercises once at the app level - all components will read from Redux store
	useLoadAllExercisesRawQuery();

	// Load all muscles once at the app level - all components will read from Redux store
	useLoadAllMusclesRawQuery();

	// Load all movement-muscle relationships once at the app level - all components will read from Redux store
	useLoadAllMovementMuscleRawQuery();

	return (
		<div dir={isRTL ? 'rtl' : 'ltr'} className={cn(isRTL ? 'group/rtl' : 'group/ltr')}>
			<Header />
			<Outlet />
			<TanStackRouterDevtools />
			{shouldShowFooter && <Footer />}
			<Toaster />
		</div>
	);
}
